import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useFetchCatalogItems } from 'entities/CatalogItem/lib/useFetchCatalogItems';
import { useFetchCategories } from 'entities/Category/lib/useFetchCategories';
import { getSelectedCategoryIdToFetch } from 'entities/Category/model/selectors/categorySelectors';
import { ReviewOrderButton, ReviewOrderFooter } from 'features/AddItemsToOrder';
import { addItemsToOrderIsLoading } from 'features/AddItemsToOrder/model/selectors/addItemsToOrderSelectors';
import { getSearchCatalogItemIsActive } from 'features/SearchCatalogItems/model/selectors/searchCatalogItemsSelectors';
import {
    PropertyCatalog,
    PropertyCatalogItemsMoveTo,
} from 'widgets/PropertyCatalog';
import { SearchCatalogItems } from 'widgets/SearchCatalogItems';

// TODO Review this component
export const OrderMarketplacePage = () => {
    const location = useLocation();

    const isLoadingUpdateOrder = useSelector(addItemsToOrderIsLoading);
    const isActive = useSelector(getSearchCatalogItemIsActive);
    const selectedCategoryId = useSelector(getSelectedCategoryIdToFetch);

    const orderType = location.state?.orderType;

    const { onFetchGlobalCategories } = useFetchCategories();
    const { onFetchCatalogItems } = useFetchCatalogItems();

    useEffect(() => {
        onFetchGlobalCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (selectedCategoryId) {
            onFetchCatalogItems(true);
        }
    }, [selectedCategoryId, onFetchCatalogItems]);

    return (
        <Box display="flex" flexDirection="column">
            <Box sx={{ marginBottom: '16px' }}>
                <SearchCatalogItems
                    mode="global"
                    moveTo={PropertyCatalogItemsMoveTo.ORDER}
                    expandable
                />
            </Box>

            {!isActive && (
                <>
                    <Box
                        display="flex"
                        overflow="hidden"
                        height="calc(100vh - 466px)"
                    >
                        <PropertyCatalog
                            isEditing
                            moveTo={PropertyCatalogItemsMoveTo.ORDER}
                        />
                    </Box>
                    <ReviewOrderFooter>
                        <ReviewOrderButton
                            isLoadingUpdateOrder={isLoadingUpdateOrder}
                            orderType={orderType}
                            itemsMode="global"
                        />
                    </ReviewOrderFooter>
                </>
            )}
        </Box>
    );
};
